import styled from 'styled-components';

interface TagProps {
  bgColor: string;
  color: string;
}

export const Tag = styled.div<TagProps>`
  font-size: 13px;
  border-radius: 2px;
  padding: 6px 12px;
  height: 22px;
  // width: 80px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => props.bgColor};
  color: ${(props) => props.color};
`;
